import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AnimatedBackground from '../components/AnimatedBackground';
import { fireEvent } from '../utils/funnelEvents';
import ArticleStructuredData from '../components/ArticleStructuredData';
import BusinessHeader from '../components/BusinessHeader';
import DemoShowcase from '../components/DemoShowcase';
import WorksWithSection from '../components/WorksWithSection';

// Business page components
import BusinessHero from './business/BusinessHero';
import BusinessOverview from './business/BusinessOverview';
import EnterpriseFeatures from './business/EnterpriseFeatures';
import EnterpriseIntegration from './business/EnterpriseIntegration';
import AdvancedSecurity from './business/AdvancedSecurity';
import RuleBasedSorting from './business/RuleBasedSorting';
import IndustriesSection from './business/IndustriesSection';
import BusinessPricing from './business/BusinessPricing';
import CompetitivePositioning from './business/CompetitivePositioning';
import WaitlistSignup from './business/WaitlistSignup';

const BusinessPage = () => {
  useEffect(() => {
    fireEvent('team_page_view', { vertical: 'business' });
  }, []);

  return (
    <>
      <Helmet>
        <title>Sortio for Teams - $29/seat AI File Organization, Shipping Today</title>
        <meta name="description" content="Sortio for teams files documents per client, per matter, per project at team scale. Shared rules, admin console, and double the Pro AI allowance per seat, pooled across your team, for $29 per seat per month. Team Pro is available today; ask us about Enterprise needs like SSO or dedicated deployments." />
      </Helmet>
      <ArticleStructuredData
        title="Sortio for Teams - $29/seat AI File Organization, Shipping Today"
        description="Sortio for teams files documents per client, per matter, per project at team scale. Shared rules, admin console, and double the Pro AI allowance per seat, pooled across your team, for $29 per seat per month. Team Pro is available today; ask us about Enterprise needs like SSO or dedicated deployments."
        datePublished="2023-01-01T00:00:00.000Z"
        dateModified="2023-01-01T00:00:00.000Z"
        authorName="Sortio Team"
      />

      <BusinessHeader />
      <BusinessHero />

      <div className="relative">
        <AnimatedBackground variant="business" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
          <div className="">
            {/* Main Content */}
            <div className="prose prose-invert max-w-none">
              <DemoShowcase />

              <section id="overview">
                <BusinessOverview />
              </section>
              
              <section id="features">
                <EnterpriseFeatures />
              </section>
              
              <section id="integrations">
                <EnterpriseIntegration />
              </section>
              
              <section id="security">
                <AdvancedSecurity />
                <RuleBasedSorting />
              </section>
              
              <section id="industries">
                <IndustriesSection />
              </section>

              <section id="works-with">
                <WorksWithSection />
              </section>

              <section id="pricing">
                <BusinessPricing />
                <CompetitivePositioning />
              </section>
              
              <section id="waitlist">
                <WaitlistSignup />
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessPage;